var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPan4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 93,
    viewBox: "0 0 125 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.9 39.9341H81.2H76.5H24.5C23.7 39.9341 23 40.6341 23 41.4341V52.9341C23 58.2341 27.3 62.6341 32.7 62.6341H68.3C73.6 62.6341 78 58.3341 78 52.9341V50.3341H97.7C100.9 50.3341 103.5 47.7341 103.5 44.5341V41.3341C103.4 40.6341 102.7 39.9341 101.9 39.9341ZM74.9 52.9341C74.9 56.6341 71.9 59.6341 68.2 59.6341H32.7C29 59.6341 26 56.6341 26 52.9341V42.9341H74.9V48.8341V52.9341ZM77.9 42.9341H79.6V47.3341H77.9V42.9341ZM100.4 44.6341C100.4 46.1341 99.2 47.4341 97.6 47.4341H82.6V43.0341H100.3V44.6341H100.4Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1992 72.6H67.6992L66.9992 69.2C66.8992 68.5 66.1992 68 65.4992 68H34.8992C34.1992 68 33.5992 68.5 33.3992 69.2L32.6992 72.6H25.6992C24.8992 72.6 24.1992 73.3 24.1992 74.1C24.1992 74.9 24.8992 75.6 25.6992 75.6H33.8992H66.4992H70.1992C70.9992 75.6 71.6992 74.9 71.6992 74.1C71.6992 73.3 71.0992 72.6 70.1992 72.6ZM36.0992 70.9H64.2992L64.5992 72.5H35.7992L36.0992 70.9Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6992 72.6001H74.1992C73.3992 72.6001 72.6992 73.3001 72.6992 74.1001C72.6992 74.9001 73.3992 75.6001 74.1992 75.6001H74.6992C75.4992 75.6001 76.1992 74.9001 76.1992 74.1001C76.1992 73.3001 75.5992 72.6001 74.6992 72.6001Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPan4);
export default __webpack_public_path__ + "static/media/pan4.80c47c3289a47f665cd320a6ebcde81a.svg";
export { ForwardRef as ReactComponent };